import { ReactNode, createContext, useContext } from "react";
import { useFilterPatient } from "./filter-patient.hook";

const FilterPatientContext = createContext(
  {} as ReturnType<typeof useFilterPatient>
);
export function useFilterPatientContext() {
  return useContext(FilterPatientContext);
}

interface FilterPatientProviderProps {
  children: ReactNode;
}
export function FilterPatientProvider({
  children,
}: FilterPatientProviderProps) {
  return (
    <FilterPatientContext.Provider value={useFilterPatient()}>
      {children}
    </FilterPatientContext.Provider>
  );
}